// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-734146b6]:disabled {\n  cursor: not-allowed;\n}\nlabel.is-disabled[data-v-734146b6] {\n  color: #7a7a7a;\n}\n.tip-icon[data-v-734146b6] {\n  height: 1em;\n  display: inline-block;\n}", ""]);
// Exports
module.exports = exports;
